<template>
  <header
    class="nav-bar from-skin-gradient-from to-skin-gradient-to shadow-md shadow-gray-500 z-10"
  >
    <div class="nav-bar-size">
      <div class="nav-bar-position">
        <img
          class="logo-size"
          src="@/assets/vaitty_navbar_desktop.svg"
          alt="Rapi Hogar"
        />
      </div>
    </div>
  </header>
</template>

<style scoped></style>
